<div class="content-body" [formGroup]="form">
  <div class="section">
    <ng-container *ngIf="hasDefault">
      <div class="service-title">
        <div></div>
        <div>
          <h4>{{ 'brand.orderChargeLimits-template.minCharge' | translate }}</h4>
        </div>
        <div>
          <h4>{{ 'brand.orderChargeLimits-template.maxCharge' | translate }}</h4>
        </div>
      </div>

      <div class="limits">
        <div class="scheduled-text">
          Store Limit
        </div>
        <mat-form-field class="minimum-charge">
          <input matInput
                 type="number"
                 data-qa-label="MinimumCharge"
                 min="0"
                 txpNumbersOnly
                 formControlName="minimum"/>
          <mat-error *ngIf="form.get('minimum')?.errors; let errors">
            <mat-error *ngIf="errors.required">
              {{ 'form.error.required' | translate }}
            </mat-error>
          </mat-error>
        </mat-form-field>
        <mat-form-field class="maximum-charge">
          <input matInput
                 type="number"
                 data-qa-label="MaximumCharge"
                 min="0"
                 txpNumbersOnly
                 formControlName="maximum"/>
          <mat-error *ngIf="form.get('maximum')?.errors; let errors">
            <mat-error *ngIf="errors.required">
              {{ 'form.error.required' | translate }}
            </mat-error>
          </mat-error>
        </mat-form-field>
      </div>
    </ng-container>

    <div class="service-title">
      <div>
        <h4>{{ 'brand.settings.serviceTypes.serviceTypes' | translate }}</h4>
      </div>
      <div>
        <h4>{{ 'brand.orderChargeLimits-template.minCharge' | translate }}</h4>
      </div>
      <div>
        <h4>{{ 'brand.orderChargeLimits-template.maxCharge' | translate }}</h4>
      </div>
    </div>

    <div class="content">
      <ng-container *ngFor="let item of dispositionKeys" formGroupName="serviceTypes">
        <mat-divider class="divide"></mat-divider>
        <div class="limits" [formGroupName]="$any(item)">
          <div class="scheduled-text">
            {{ 'brand.settings.serviceTypes.' + item| translate }}
          </div>
          <mat-form-field class="minimum-charge">
            <input matInput
                   type="number"
                   data-qa-label="MinimumCharge"
                   min="0"
                   txpNumbersOnly
                   formControlName="minimum"/>
            <mat-error *ngIf="form.get('serviceTypes.' + item + '.minimum')?.errors; let errors">
              <mat-error *ngIf="errors.required">
                {{ 'form.error.required' | translate }}
              </mat-error>
            </mat-error>
          </mat-form-field>
          <mat-form-field class="maximum-charge">
            <input matInput
                   type="number"
                   data-qa-label="MaximumCharge"
                   min="0"
                   txpNumbersOnly
                   formControlName="maximum"/>
            <mat-error *ngIf="form.get('serviceTypes.' + item + '.maximum')?.errors; let errors">
              <mat-error *ngIf="errors.required">
                {{ 'form.error.required' | translate }}
              </mat-error>
            </mat-error>
          </mat-form-field>
        </div>
      </ng-container>
    </div>
  </div>
</div>
